import styled from "styled-components";
import Chip from "../Chip";
import Table from "../DataTable";
import ListWithPagination from "../ListsWithPagination";
import LinkPriceListingModal from "./LinkPriceListingModal";
import { Colors } from "../../config/Constants";
import dayjs from "dayjs";

interface Props {
  data: any[];
  onCancelSoldout: (id: string) => void;
  isTableDataLoading: boolean;
}

const SoldoutTable = ({ data, onCancelSoldout, isTableDataLoading }: Props) => {
  const columns = [
    {
      path: "date",
      label: "Date",
      content: (data:any) => <div>{dayjs(data?.date).format('DD MMM YYYY')}</div>,
    },
    {
      path: "products",
      label: "Products",
      content: (data: any) => (
        <div>
          {data?.isAllIncluded
            ? "All Products"
            : data?.products.map((prd: any) => prd.productName).join(",")}
        </div>
      ),
    },
    {
      path: "reason",
      label: "Reason",
      content: (data: any) => (
        <div style={{ width: "300px",fontSize:'12px' }}>{data?.comment || "-"}</div>
      ),
    },

    {
      label: "Action",
      key: "edit",
      content: (data: any) => (
        <ActionButton onClick={() => onCancelSoldout(data._id)}>
          Cancel Soldout
        </ActionButton>
      ),
    },
  ];

  return (
    <>
      <TableWrapper>
        <Table columns={columns} data={data} />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={"Product Details"}
          onRowClick={undefined}
          hidePagination={true}
          currentPage={0}
          totalData={0}
          rowsPerPage={0}
          onPageChange={function (page: number): void {
            throw new Error("Function not implemented.");
          }}
        />
      </ListWrapper>
    </>
  );
};

const TableWrapper = styled.div`
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

const ActionButton = styled.div`
  color: ${Colors.red};
  background: transparent;
`;

export default SoldoutTable;
